module.exports = __webpack_public_path__ + "static/media/ic-arrow-2.3463fc06.svg";